import React from "react";
import { Pagination } from "@culturehq/components";
import client from "@culturehq/client";

import { useFetch, usePagination } from "app/hooks";
import { ProfileLink, RecognitionLink } from "app/links";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import LazyEditorOutput from "components/editor/LazyEditorOutput";

import ProfileTable from "./ProfileTable";

const RecognitionRow = ({ recognition }) => (
  <tr>
    <td>
      {
        recognition.creator
          ? <ProfileLink user={recognition.creator} />
          : <Trans>CultureBot</Trans>
      }
    </td>
    <td>
      <TimeDiff time={recognition.createdAt} />
    </td>
    <td className="max-width-300">
      <LazyEditorOutput output={recognition.body} />
    </td>
    <td>
      <RecognitionLink recognition={recognition} className="link action">
        <Trans>View →</Trans>
      </RecognitionLink>
    </td>
  </tr>
);

const Recognitions = ({ user }) => {
  const [page, onPageClick] = usePagination();
  const { json: { recognitions = [], pagination = {} }, loading } = useFetch(
    () => client.listUserRecognitions({ userId: user.id, page }),
    [page, user]
  );

  return (
    <>
      <ProfileTable loading={loading}>
        <thead>
          <tr>
            <th className="nowrap">
              <Trans>Recognized By</Trans>
            </th>
            <th>
              <Trans>Date</Trans>
            </th>
            <th>
              <Trans>Description</Trans>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {recognitions.map(recognition => (
            <RecognitionRow recognition={recognition} key={recognition.id} />
          ))}
          {!loading && recognitions.length < 1 && (
            <tr>
              <td colSpan={4}>
                <Trans>No recognitions received</Trans>
              </td>
            </tr>
          )}
        </tbody>
      </ProfileTable>
      <Pagination {...pagination} onClick={onPageClick} />
    </>
  );
};

export default Recognitions;
